export default __webpack_public_path__ + "static/media/vehicle.165704d8b92fa29cd3d0bc503ada88fb.svg";